import { all, put, call, takeLatest, takeEvery } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import moment from 'moment';
import ApiService from '@/services/Api';
import actions, { actionTypes } from './actions';

function setFiltersKeys(payload) {
  const { proposal_type, updated, lead_status } = payload;
  let filters = {};
  if (proposal_type && proposal_type.length) {
    filters.proposal_type = proposal_type[0];
  }
  if (lead_status && lead_status.length) {
    filters.lead_status = lead_status.join(',');
  }
  if (updated && updated.length) {
    filters.updated = `${moment(updated[0]).format('YYYY-MM-DD')},${moment(updated[1]).format('YYYY-MM-DD')}`;
  }
  return filters;
}

function* fetchLeads({ payload }) {
  const filters = setFiltersKeys(payload);
  try {
    const { data } = yield call(ApiService.fetchLeads, { ...payload, ...filters });
    yield put(actions.fetchSuccess(data));
  } catch (error) {
    yield put(actions.fetchFailed(error));
  }
}

function* fetchLeadsSummary() {
  try {
    const { data } = yield call(ApiService.fetchLeadsSummary);
    yield put(actions.fetchSummarySuccess(data));
  } catch (error) {
    yield put(actions.fetchSummaryFailed(error));
  }
}

function* changeTab({ payload }) {
  yield put(push(`/manage/leads#${payload.tabName}`));
}

export default function* () {
  yield all([
    takeLatest(actionTypes.FETCH_LEADS, fetchLeads),
    takeLatest(actionTypes.FETCH_LEADS_SUMMARY, fetchLeadsSummary),
    takeEvery(actionTypes.CHANGE_TAB, changeTab),
  ]);
}
